
const isProduction = window.location.hostname !== 'localhost';
export const API_BASE_URL =
  process.env.REACT_APP_API_URL ||
  (isProduction ? 'https://api.offerflow.pro' : 'http://localhost:8000');

export const S3_BASE_URL =
  process.env.REACT_APP_S3_BASE_URL ||
  'https://s3-bucket.sfo3.cdn.digitaloceanspaces.com/dev-folder/';




export const API_ENDPOINTS = {
  auth: {
    login: `${API_BASE_URL}/auth/login`,
    register: `${API_BASE_URL}/auth/register`,
    logout: `${API_BASE_URL}/auth/logout`,
    refresh: `${API_BASE_URL}/auth/refresh`,
  },
  
  me: `${API_BASE_URL}/v1/me`,
  updateMe: `${API_BASE_URL}/v1/update-me`,
  updatePassword: `${API_BASE_URL}/v1/update-password`,
  generateEmailConfirmation: `${API_BASE_URL}/v1/generate-email-confirmation`,
  confirmEmail: `${API_BASE_URL}/v1/confirm-email`,
  confirmPasswordReset: `${API_BASE_URL}/v1/confirm-password-reset`,
  uploadMePhoto: `${API_BASE_URL}/v1/uploud-me-photo`,
  deleteMePhoto: `${API_BASE_URL}/v1/delete-me-photo`,
  checkMe: `${API_BASE_URL}/v1/check-me`,
  
  users: {
    me: `${API_BASE_URL}/users/me`,
    update: `${API_BASE_URL}/users/me`,
    getByUid: `${API_BASE_URL}/v1/get-user-by-uid`,
    importProfileFromPdf: `${API_BASE_URL}/v1/import-profile-from-file`,
    updateBasicInfo: `${API_BASE_URL}/v1/update-user-basic-info`,
    updatePreferences: `${API_BASE_URL}/v1/update-user-preferences`,
    updateExperience: `${API_BASE_URL}/v1/update-user-experience`,
    deleteExperience: (uid: string) => `${API_BASE_URL}/v1/delete-user-experience?user_experience_uid=${uid}`,
    updateVolunteerExperience: `${API_BASE_URL}/v1/update-user-volunteer-experience`,
    deleteVolunteerExperience: (uid: string) => `${API_BASE_URL}/v1/delete-user-volunteer-experience?user_volunteer_experience_uid=${uid}`,
    updateCertifications: `${API_BASE_URL}/v1/update-user-certifications`,
    deleteCertifications: (uid: string) => `${API_BASE_URL}/v1/delete-user-certifications?user_certifications_uid=${uid}`,
    updateEducation: `${API_BASE_URL}/v1/update-user-education`,
    deleteEducation: (uid: string) => `${API_BASE_URL}/v1/delete-user-education?user_education_uid=${uid}`,
    updateLinks: `${API_BASE_URL}/v1/update-user-links`,
    deleteLinks: (uid: string) => `${API_BASE_URL}/v1/delete-user-links?user_links_uid=${uid}`,
    updateUrl: `${API_BASE_URL}/v1/update-user-url`,
    deleteUrl: (uid: string) => `${API_BASE_URL}/v1/delete-user-url?user_url_uid=${uid}`,
    updateProject: `${API_BASE_URL}/v1/update-user-project`,
    deleteProject: (uid: string) => `${API_BASE_URL}/v1/delete-user-project?user_project_uid=${uid}`,
    deleteProjectImage: (projectUid: string, imgUrl: string) => `${API_BASE_URL}/v1/delete-img-from-project?project_uid=${projectUid}&img_url=${encodeURIComponent(imgUrl)}`,
  },
  
  cvs: {
    list: `${API_BASE_URL}/v1/get-user-cvs`,
    get: (uid: string) => `${API_BASE_URL}/v1/get-cv-by-uid?cv_uid=${uid}`,
    create: `${API_BASE_URL}/v1/create-cv`,
    createWithFile: `${API_BASE_URL}/v1/create-cv-with-file`,
    updateInfo: (uid: string) => `${API_BASE_URL}/v1/cv-update-info?cv_uid=${uid}`,
    updateWorkExperience: (uid: string) => `${API_BASE_URL}/v1/cv-update-work-experience?cv_uid=${uid}`,
    reorderWorkExperience: (uid: string) => `${API_BASE_URL}/v1/reorder-work-experience?cv_uid=${uid}`,
    updateVolunteerExperience: (uid: string) => `${API_BASE_URL}/v1/cv-update-volunteer-experience?cv_uid=${uid}`,
    reorderVolunteerExperience: (uid: string) => `${API_BASE_URL}/v1/reorder-volunteer-experience?cv_uid=${uid}`,
    updateEducation: (uid: string) => `${API_BASE_URL}/v1/cv-update-education?cv_uid=${uid}`,
    reorderEducation: (uid: string) => `${API_BASE_URL}/v1/reorder-education?cv_uid=${uid}`,
    updateCertifications: (uid: string) => `${API_BASE_URL}/v1/cv-update-certifications?cv_uid=${uid}`,
    reorderCertifications: (uid: string) => `${API_BASE_URL}/v1/reorder-certifications?cv_uid=${uid}`,
    updateProjects: (uid: string) => `${API_BASE_URL}/v1/cv-update-projects?cv_uid=${uid}`,
    reorderProjects: (uid: string) => `${API_BASE_URL}/v1/reorder-projects?cv_uid=${uid}`,
    updateLinkBlocks: (uid: string) => `${API_BASE_URL}/v1/cv-update-link-blocks?cv_uid=${uid}`,
    renameSection: (uid: string) => `${API_BASE_URL}/v1/rename-cv-section?cv_uid=${uid}`,
    reorderSections: (uid: string) => `${API_BASE_URL}/v1/reorder-cv-sections?cv_uid=${uid}`,
    updateSettings: (uid: string) => `${API_BASE_URL}/v1/update-cv-settings?cv_uid=${uid}`,
    updateHeadshotLayout: (uid: string) => `${API_BASE_URL}/v1/update-headshot-layout?cv_uid=${uid}`,
    uploadHeadshotImage: (uid: string) => `${API_BASE_URL}/v1/upload-headshot-image?cv_uid=${uid}`,
    removeHeadshot: (uid: string) => `${API_BASE_URL}/v1/remove-headshot?cv_uid=${uid}`,
    updateTemplate: (uid: string) => `${API_BASE_URL}/v1/update-cv-template?cv_uid=${uid}`,
    deleteEntity: `${API_BASE_URL}/v1/delete-cv-entity`,
    delete: (uid: string) => `${API_BASE_URL}/v1/delete-cv?cv_uid=${uid}`,
    duplicate: (uid: string) => `${API_BASE_URL}/v1/duplicate-cv?cv_uid=${uid}`,
    exportPdf: `${API_BASE_URL}/v1/export-pdf`,
    createSkillsGroup: (uid: string) => `${API_BASE_URL}/v1/create-cv-skills-group?cv_uid=${uid}`,
    updateSkills: (uid: string) => `${API_BASE_URL}/v1/update-cv-skills?cv_uid=${uid}`,
    updateSkillGroup: (uid: string) => `${API_BASE_URL}/v1/update-skill-group?cv_uid=${uid}`,
    createCustomSection: (uid: string) => `${API_BASE_URL}/v1/create-custom-cv-section?cv_uid=${uid}`,
    updateCustomSection: (uid: string) => `${API_BASE_URL}/v1/update-custom-cv-section?cv_uid=${uid}`,
    updateCustomSectionContent: (uid: string) => `${API_BASE_URL}/v1/update-custom-cv-section-content?cv_uid=${uid}`,
    reorderCustomSectionContent: (uid: string, sectionUid: string) => `${API_BASE_URL}/v1/reorder-custom-cv-section-content?cv_uid=${uid}&section_uid=${sectionUid}`,
  },
  
  kanbans: {
    list: `${API_BASE_URL}/v1/get-user-kanbans`,
    listWithStats: `${API_BASE_URL}/v1/get-user-kanbans-with-stats`,
    create: `${API_BASE_URL}/v1/create-kanban`,
    delete: `${API_BASE_URL}/v1/delete-kanban`,
    get: (id: string) => `${API_BASE_URL}/v1/get-kanban-by-uid?uid=${id}`,
    update: (id: string) => `${API_BASE_URL}/kanbans/${id}`,
    rename: `${API_BASE_URL}/v1/rename-kanban`,
    changeSwimlaneName: `${API_BASE_URL}/v1/change-swimlane-name`,
    createSwimlane: `${API_BASE_URL}/v1/create-swimlane`,
    deleteSwimlane: (swimlaneUid: string, kanbanUid: string) => `${API_BASE_URL}/v1/delete-swimlane?swimlane_uid=${swimlaneUid}&kanban_uid=${kanbanUid}`,
    analytics: (boardId: string) => `${API_BASE_URL}/v1/kanbans/${boardId}/analytics`,
  },
  
  jobs: {
    list: (kanbanId: string) => `${API_BASE_URL}/kanbans/${kanbanId}/jobs`,
    listByKanban: (kanbanId: string) => `${API_BASE_URL}/v1/get-kanban-jobs?kanban_uid=${kanbanId}`,
    myJobs: `${API_BASE_URL}/v1/get-jobs-me`,
    create: `${API_BASE_URL}/v1/create-job`,
    get: (kanbanId: string, jobId: string) => `${API_BASE_URL}/kanbans/${kanbanId}/jobs/${jobId}`,
    update: `${API_BASE_URL}/v1/update-job`,
    delete: (jobUid: string) => `${API_BASE_URL}/v1/delete-job?job_uid=${jobUid}`,
    updateSwimlane: (jobUid: string, newSwimlaneUid: string) => `${API_BASE_URL}/v1/update-job-swimlane?job_uid=${jobUid}&new_swimlane_uid=${newSwimlaneUid}`,
  },
  
  jobNotes: {
    list: (jobId: string) => `${API_BASE_URL}/v1/get-job-notes?job_uid=${jobId}`,
    create: `${API_BASE_URL}/v1/create-job-note`,
    get: (jobId: string, noteId: string) => `${API_BASE_URL}/jobs/${jobId}/notes/${noteId}`,
    update: `${API_BASE_URL}/v1/update-job-note`,
    delete: (noteUid: string) => `${API_BASE_URL}/v1/delete-job-note?note_uid=${noteUid}`,
  },
  
  activities: {
    list: `${API_BASE_URL}/activities`,
    create: `${API_BASE_URL}/v1/create-activity`,
    get: (id: string) => `${API_BASE_URL}/activities/${id}`,
    update: (activityUid: string) => `${API_BASE_URL}/v1/update-activity?activity_uid=${activityUid}`,
    delete: (activityUid: string) => `${API_BASE_URL}/v1/delete-activity?activity_uid=${activityUid}`,
    getByKanban: (kanbanUid: string) => `${API_BASE_URL}/v1/get-all-kanban-activities?kanban_uid=${kanbanUid}`,
  },
  
  contacts: {
    list: `${API_BASE_URL}/v1/get-all-contacts`,
    getByKanban: (boardId: string) => `${API_BASE_URL}/v1/get-contact-by-kanban-linked?board_linked=${boardId}`,
    create: `${API_BASE_URL}/v1/create-contact`,
    get: (id: string) => `${API_BASE_URL}/v1/get-contact-by-uid?contact_uid=${id}`,
    update: (id: string) => `${API_BASE_URL}/v1/update-contact?contact_uid=${id}`,
    delete: (id: string) => `${API_BASE_URL}/v1/delete-contact?contact_uid=${id}`,
  },
  
  documents: {
    list: `${API_BASE_URL}/v1/get-user-documents`,
    create: `${API_BASE_URL}/v1/create-document`,
    upload: `${API_BASE_URL}/v1/upload-document-file`,
    get: (id: string) => `${API_BASE_URL}/v1/get-document-by-uid?document_uid=${id}`,
    update: `${API_BASE_URL}/v1/update-document`,
    delete: `${API_BASE_URL}/v1/delete-document`,
    getByKanban: `${API_BASE_URL}/v1/get-kanban-jobs-documents`,
  },
  
  timelines: {
    list: (jobId: string) => `${API_BASE_URL}/v1/get-job-timeline?job_uid=${jobId}`,
  },
  
  aiTasks: {
    create: `${API_BASE_URL}/v1/create-ai-task`,
    getByStatuses: (jobUid: string) => `${API_BASE_URL}/v1/get-job-ai-tasks-by-statuses?job_uid=${jobUid}`,
  },
  
  aiCv: {
    createTask: `${API_BASE_URL}/v1/create-ai-cv-task`,
    getTasks: (cvUid: string) => `${API_BASE_URL}/v1/get-ai-cv-tasks?cv_uid=${cvUid}`,
    getTaskDetails: (taskUid: string) => `${API_BASE_URL}/v1/get-ai-cv-task-details?task_uid=${taskUid}`,
    markCompleted: (taskUid: string) => `${API_BASE_URL}/v1/mark-ai-cv-task-as-completed?task_uid=${taskUid}`,
  },
  
  subscriptions: {
    getUserSubscription: `${API_BASE_URL}/v1/get-user-subscription`,
    getUserUsage: `${API_BASE_URL}/v1/get-user-usage`,
    getPlans: `${API_BASE_URL}/v1/get-subscription-plans`,
    cancelSubscription: `${API_BASE_URL}/v1/cancel-user-subscription`,
  },

  admin: {
    users: `${API_BASE_URL}/v1/admin/users`,
    user: (uid: string) => `${API_BASE_URL}/v1/admin/users/${uid}`,
    updateUser: (uid: string) => `${API_BASE_URL}/v1/admin/users/${uid}`,
    impersonate: (uid: string) => `${API_BASE_URL}/v1/admin/users/${uid}/impersonate`,
    grantSubscription: (uid: string) => `${API_BASE_URL}/v1/admin/users/${uid}/grant-subscription`,
    revokeSubscription: (uid: string, subUid: string) => `${API_BASE_URL}/v1/admin/users/${uid}/subscriptions/${subUid}`,
    userPayments: (uid: string) => `${API_BASE_URL}/v1/admin/users/${uid}/payments`,
    stats: `${API_BASE_URL}/v1/admin/stats`,
    aiUsage: (period: string) => `${API_BASE_URL}/v1/admin/ai-usage?period=${period}`,
    aiSettings: `${API_BASE_URL}/v1/admin/ai-settings`,
    plans: `${API_BASE_URL}/v1/admin/plans`,
    updatePlan: (uid: string) => `${API_BASE_URL}/v1/admin/plans/${uid}`,
    triggerAnalytics: `${API_BASE_URL}/v1/admin/trigger-analytics`,
    blog: `${API_BASE_URL}/v1/admin/blog`,
    blogPost: (uid: string) => `${API_BASE_URL}/v1/admin/blog/${uid}`,
    blogPostImage: (uid: string) => `${API_BASE_URL}/v1/admin/blog/${uid}/image`,
    blogDeploy: `${API_BASE_URL}/v1/admin/blog/deploy`,
    blogCreateCategory: `${API_BASE_URL}/v1/admin/blog/categories`,
    blogCategory: (uid: string) => `${API_BASE_URL}/v1/admin/blog/categories/${uid}`,
    blogCreateTag: `${API_BASE_URL}/v1/admin/blog/tags`,
    blogTag: (uid: string) => `${API_BASE_URL}/v1/admin/blog/tags/${uid}`,
  },
  blog: {
    categories: `${API_BASE_URL}/v1/blog/categories`,
    tags: `${API_BASE_URL}/v1/blog/tags`,
  },

  payments: {
    createCheckout: `${API_BASE_URL}/v1/create-checkout`,
    getPaymentHistory: `${API_BASE_URL}/v1/get-payment-history`,
    getPaymentInvoice: (paymentId: string) => `${API_BASE_URL}/v1/get-payment-invoice/${paymentId}`,
  },
};

export const config = {
  apiUrl: API_BASE_URL,
  endpoints: API_ENDPOINTS,
};

export default config;

